'use strict'

/**
 * Controller for the Save component.
 *
 * @class SaveController
 */
class SaveController {
  constructor($attrs) {
    this._$attrs = $attrs
  }

  /**
   * Set the appropriate text for the save button.
   *
   * @method getButtonText
   *
   * @return {String} The button text to display.
   */
  getButtonText() {
    if (this.saving) {
      return 'Saving...'
    } else {
      return !this.lastUpdated ? 'Save' : 'Save Changes'
    }
  }

  $postLink() {
    this._$attrs.$addClass('vd-save')
  }
}

SaveController.$inject = ['$attrs']

export default SaveController
